<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>保险说明</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page" style="padding-bottom:0">
      <div class="bg-white">
        <div class="padding-15">
          <p class="margin-15">这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。</p>
          <p class="margin-15">这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。</p>
          <p class="margin-15">这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。</p>
        </div>
        <div class="liner"></div>
        <div>
          <p class="margin-x-15 padding-15 gray">点击购买按钮，家长将收到保单信息，家长完成购买和支付过程，产生的保单费用20元须返还给家长或从托管费用中除</p>
          <div class="margin-x-15 padding-15" v-if="isChecked">
            <span class="button button-block button-primary button-rounded disabled">给孩子买一份安全保障</span>
          </div>
          <template v-else>
          <div class="insurance text-center">
            <mt-checklist
              :value="isAgree"
              :options="['我已阅读并同意相关条款']">
            </mt-checklist>
          </div>
          <div class="margin-x-15 padding-15">
            <span class="button button-block button-primary button-rounded" @click="checkAgree()">给孩子买一份安全保障</span>
          </div>
          </template>
        </div>
      </div>
      <!-- <mt-popup
        v-model="popupVisible">
        <div style="width:100vw">
          <div class="margin-15 padding-15">
            <div class="bg-white padding-15">
              <img src="../../assets/images/ewm-teacher.png" width="100%">
              <p class="text-center">此二维码只适用于您的孩子***，请勿转发他人，否则投保不成功园点不承担责任</p>
            </div>
          </div>
        </div>

      </mt-popup> -->
    </div>

    <div class="maskdiv" v-show="!isHideInsertInsure">
      <div class="popover">
        <div class="pop-wrap text-center">
          <p class="margin-15">给孩子买一份安全保障</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
              <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="insertInsureGl()">确定</a></div>
              <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideInsertInsure = true">取消</a></div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { service } from '../../service'
import { Toast } from 'mint-ui'
// import { Checklist, Popup } from 'mint-ui'
// Vue.component(Checklist.name, Checklist)
// Vue.component(Popup.name, Popup)

export default {
  data () {
    return {
      // popupVisible: false
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      insert_insure_gl_para: service.setPara('insertInsureGl'),
      get_insure_list_para: service.setPara('getInsureList'),
      get_curche_insure_list_para: service.setPara('getCurcheInsureList'),
      isChecked: false,
      isHideInsertInsure: true,
      isAgree: ['我已阅读并同意相关条款']
    }
  },
  mounted: function () {
    this.getCurcheInsureList()

    let that = this
    $('.maskdiv').mouseup(function (e) {
      var _con = $('.maskdiv .popover:visible')   // 设置目标区域
      if (_con.length == 0) {
        return
      }
      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
        that.isHideInsertInsure = true
      }
    })
  },
  methods: {
    getCurcheInsureList: function () {
      this.get_curche_insure_list_para.curcheId = this.cookie_login_data.curcheId

      let that = this
      let obj = {context: this, para: this.get_curche_insure_list_para, successFun: (response) => {
        if (response.data.length > 0) {
          that.isChecked = true
        }
      }}
      service.request(obj)
    },
    insertInsureGl: function () {
      let that = this
      let obj = {context: this, para: this.get_insure_list_para, successFun: (response) => {
        if (response.data.length == 0) {
          Toast('暂无保险可以选择')
        } else {
          that.insert_insure_gl_para.curcheId = that.cookie_login_data.curcheId
          that.insert_insure_gl_para.insureTypeId = response.data[0].typeId
          that.insert_insure_gl_para.insureTypeName = response.data[0].typeName
          that.insert_insure_gl_para.teacherId = that.cookie_login_data.teacherId
          let obj1 = {context: that, para: that.insert_insure_gl_para, successFun: (response) => {
            that.isChecked = true
            that.isHideInsertInsure = true
            Toast('操作成功')
          }}
          service.request(obj1)
        }
      }}
      service.request(obj)
    },
    checkAgree: function () {
      if (this.isAgree[0] != '我已阅读并同意相关条款') {
        Toast('请阅读并同意相关条款')
        return
      }
      this.isHideInsertInsure = false
    }
  }
}
</script>
<style scoped>
.mint-cell{font-size:14px;}
.mint-cell:before,.mint-cell:after{border:none;}
.mint-popup{background:none;}
</style>


// WEBPACK FOOTER //
// Insurance.vue?082a856c